import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "content", "background" ]

    connect() {
        document.addEventListener('turbo:submit-end', this.handleSubmit.bind(this))
        document.addEventListener('keydown', this.handleEscape.bind(this))
    }

    disconnect() {
        document.removeEventListener('turbo:submit-end', this.handleSubmit)
        document.removeEventListener('keydown', this.handleEscape)
    }

    close(e) {
        this.element.remove();
    }

    handleEscape(e) {
        if (event.defaultPrevented) {
          return;
        }
        if(event.key === "Escape") {
            this.close()
        }
    }

    handleSubmit(e) {
        const redirected = e?.detail?.fetchResponse?.response?.redirected
        const rspStatus = e?.detail?.fetchResponse?.response?.status
        if (e.detail.success && rspStatus != 204 && rspStatus != 202) {
            if (!redirected) {
                this.close()
            }
        }
    }
}
